import actionTypes from './actionTypes';

export const create = (data) => ({
  type: actionTypes.CREATE,
  payload: {
    data,
  },
});

export const creating = (data) => ({
  type: actionTypes.CREATING,
  payload: {
    data,
  },
});

export const created = (data) => ({
  type: actionTypes.CREATED,
  payload: {
    data,
  },
});

export const failed = () => ({
  type: actionTypes.FAILED,
  payload: {},
});

export const fetchFleets = (fleetName) => ({
  type: actionTypes.FETCH_FLEETS,
  payload: {
    fleetName,
  },
});

export const fetchedFleets = (availableFleets) => ({
  type: actionTypes.FETCHED_FLEETS,
  payload: {
    availableFleets,
  },
});
